// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__355g3","footer":"ReportModalFilter_footer__1IuSQ"};